<template>
  <bonus-dialog>
    <template v-slot:title>
      <div
        v-for="desc of missionDescription"
        :key="desc">
        {{ desc }}
      </div>
    </template>
    <div class="flex row no-wrap justify-center">
      <div
        class="bonusDialogWait_btn bonusDialogWait_btn_watch"
        @click="$emit('handle-continue-watch', 'WAIT')">继续看</div>
      <div class="bonusDialogWait_btn bonusDialogWait_btn_promo">
        <div
          class="bonusDialogWait_btn_promo_link"
          @click="handleOpenLink">{{bonusInfo.btnText}}</div>
      </div>
    </div>
  </bonus-dialog>
</template>

<script>
import BonusDialog from './BonusDialog'
import { missionType, xbbEventType, xbbAction } from '../utils'
export default {
  name: 'BonusDialogWait',
  components: {
    BonusDialog
  },
  props: {
    mission: {
      type: Object,
      default: null
    }
  },
  computed: {
    missionDescription () {
      if (this.mission && this.mission.Description) {
        return this.mission.Description.split(' ')
      }

      return ['请查看推广赚钱', '即可继续享有观影送钱！']
    },
    bonusInfo () {
      const { ActionType: actionType } = this.mission || {}
      const { cid, userid, domain, promoUrl } = this.$store.state.xbbBonus
      let result = null

      switch (actionType) {
        case missionType.bind:
        case missionType.guestBind:
          result = {
            btnText: '去绑定',
            XBB_PROMO_URL: null
          }
          break
        case missionType.view:
          result = {
            btnText: '去查看',
            XBB_PROMO_URL: `${promoUrl}?check=true&cid=${cid}&userid=${userid}&tagId=${this.mission && this.mission.TagId}&domain=${domain}`
          }
          break
        case missionType.guest:
          result = {
            btnText: '去查看',
            XBB_PROMO_URL: null
          }
          break
        default:
          result = {
            btnText: '去推广',
            XBB_PROMO_URL: `${promoUrl}?check=false&cid=${cid}&userid=${userid}&tagId=${this.mission && this.mission.TagId}&domain=${domain}`
          }
          break
      }
      return result
    }
  },
  methods: {
    /**
     * 因為ios app 當頁開啟再返回後卻沒有重整，導致彈窗沒被關閉，所以使用這方式強迫關閉
     */
    handleOpenLink () {
      const { ActionType: actionType } = this.mission || {}
      this.$emit('close-dialog')
      switch (actionType) {
        case missionType.guest:
        case missionType.guestBind:
          xbbAction(xbbEventType.login)
          break
        case missionType.bind:
          xbbAction(xbbEventType.bankcard)
          break
        default:
          window.location.href = this.bonusInfo.XBB_PROMO_URL
          break
      }
    }
  }
}
</script>

<style scoped>
.bonusDialogWait_btn {
  width: calc(100% - 50px);
  height: 40px;
  margin: 20px 10px 0 10px;
  font-size: 15px;
  font-weight: 700;
  line-height: 40px;
  text-align: center;
  border: none;
  border-radius: 20px;
}

.bonusDialogWait_btn_watch {
  color: #262626;
  background-color: #f2f2f2;
}

.bonusDialogWait_btn_promo {
  color: #f2f2f2;
  background-color: #5e626d;
}

.bonusDialogWait_btn_promo_link {
  display: block;
  width: 100%;
  height: 100%;
  color: #fff;
  text-decoration: none;
}

.flex {
  display: flex;
}

.row {
  display: flex;
}

.no-wrap {
  flex-wrap: nowrap;
}

.justify-center {
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/views/xbb/components/BonusDialogWait.vue